<template lang="pug">
  div(v-if="dataIsLoaded")
    div.detail-inner-icon-view(v-if="AppState.viewMode === 'simple'", :class="{'alive': device.alive === 1}")
      b-container(fluid)
        div.detail-header
          button.plain-button(@click="goback")
            icon(name="chevron-left", style="vertical-align: -2px;")
            span &nbsp;&nbsp;{{$t('back')}}
          span {{device.alias}}
          span.device_memo.d-none.d-md-inline.d-lg-inline.d-xl-inline(@click="updateMemo") {{$t('columns.memo')}}: {{device.memo || $t('empty')}}
          b-breadcrumb.lmm-breadcrumb.device_memo.d-none.d-md-flex.d-lg-flex.d-xl-flex(:items="breadcrumb")
        b-row.detail-body
          b-col(cols="12", md="4")
            div.preview
              div.offline-block(v-if="device.alive === 0")
                div OFFLINE
              img.preview-img(
                v-if="device.guid",
                :src="`${AppState.Path.live}/${device.guid}.${device._ext}`",
                @error="onThumbError")
            b-button-group(size="sm", v-if="device.alive === 1")
              b-button(
                v-if="device.approval === 1",
                variant="primary",
                :disabled="!AppState.perm.CSRemoteControl",
                @click="openModal('remote', device)")
                icon.mr-1.dev-action-button(name="play", scale="1.2")
                span {{$t('remote.remote.title')}}
              b-button(
                v-else,
                variant="dark",
                :disabled="!AppState.perm.CSRemoteControl",
                @click="approvalStatus(device)")
                icon.mr-1.dev-action-button(name="exclamation-triangle", scale="1.2")
                span {{$t('remote.approve.desc')}}
              b-button(v-if="AppState.perm.CSFileManager && !AppState.isMobile", @click="openModal('transfer', device)", :disabled="device.disable_filetransfer || device.approval === 0")
                icon.dev-action-button(name="copy", scale="1.2")
                span.sr-only {{$t('remote.transfer.title')}}
            div.mt-2(style="color: #c7c7c7;font-size: 12px;") updated: {{device.system_time}}
          b-col(cols="12", md="8")
            b-row
              b-card-group.w-100
                b-card.process-card.m-1(
                  :header="'CPU ' + $t('use_rate')",
                  header-tag="div",
                  :footer="device.processor",
                  footer-tag="div")
                  div.value
                    | {{device.cpu_usage}}
                    icon(name="percent")
                  div(slot="footer")
                    | {{device.processor || 'NO DATA'}}
                b-card.process-card.m-1(
                  :header="'HDD ' + $t('use_rate')",
                  header-tag="div")
                  div.value
                    | {{device.hdd_usage}}
                    icon(name="percent")
                  div(slot="footer")
                    | {{device.hdd_uses | comma}}MB
                    | /
                    | {{device.hdd_capacity | comma}}MB
                b-card.process-card.m-1(
                  :header="'Memory ' + $t('use_rate')",
                  header-tag="div")
                  div.value
                    | {{device.memory_usage}}
                    icon(name="percent")
                  div(slot="footer")
                    | {{device.memory_uses | comma}}MB
                    | /
                    | {{device.memory_capacity | comma}}MB
            b-row
              b-card.w-100(no-body)
                table.table.table-border(style="margin:0")
                  tr
                    th Fan {{$t('speed')}}
                    td {{device.fan_speed_id}}
                    th {{$t('timezone')}}
                    td {{device.time_zone}}
                  tr
                    th CPU {{$t('temperature')}}
                    td {{device.cpu_temp}}
                    th HDD {{$t('temperature')}}
                    td {{device.hdd_temp}}
                  tr
                    th {{$t('running_time')}}
                    td {{device.running_time}}
                    th {{$t('system_time')}}
                    td {{device.system_time}}
                  tr
                    th {{$t('columns.last_connected_time')}}
                    td {{device.last_disconnected_time | moment('YY-MM-DD')}}
                    th {{$t('remote_device')}} {{$t('version')}}
                    td {{device.current_ver}}
                      b-button(
                        v-if="device.current_ver !== device.latest_ver && device.alive === 1 && device.dev_os_id === 1",
                        size="sm",
                        variant="warning",
                        style="margin-left: 8px;",
                        @click="updateAgent")
                        icon(name="exclamation-circle")
                        span &nbsp;UPDATE
        b-row.mt-2
          b-table(
            :fields="network_fields",
            :items="[device]",
            stacked="md",
            bordered)
        b-row
          b-card.w-100.mt-2(no-body)
            b-tabs(card)
              b-tab(:title="$t('access_log')", active)
                b-table(
                  :fields="audit_fields",
                  :items="audit",
                  :empty-text="$t('no-content')",
                  stacked="md",
                  show-empty)
                  template(v-slot:cell(act_time)="{item}")
                    | {{item.act_time | moment('YY-MM-DD HH:mm')}}
                  template(v-slot:cell(action)="{item}")
                    span(v-html="$t(`audit-message[${item.act_name_id}]`, item)")
              b-tab(:title="$t('list_of_process')")
                b-table(
                  :fields="process_fields",
                  :items="process",
                  :empty-text="$t('no-content')",
                  stacked="md",
                  show-empty)
                  template(v-slot:cell(cpu)="row")
                    b-progress(:value="row.item.cpu", :max="100", show-progress, animated)
                  template(v-slot:cell(memory)="row")
                    b-progress(:value="row.item.memory", :max="100", show-progress, animated)
              b-tab(:title="$t('list_of_hardware')")
                b-table(
                  :fields="hardware_fields"
                  :items="hardware",
                  :empty-text="$t('no-content')",
                  stacked="md",
                  show-empty)
              b-tab(:title="$t('list_of_software')")
                b-table(
                  :fields="software_fields"
                  :items="software",
                  :empty-text="$t('no-content')",
                  stacked="md",
                  show-empty)
    div.detail-inner(v-else, :class="{'alive': device.alive === 1}")    
      b-container(fluid)
        div.detail-header
          button.plain-button(@click="goback")
            icon(name="chevron-left", style="vertical-align: -2px;")
            span &nbsp;&nbsp;{{$t('back')}}
          span {{device.alias}}
          span.device_memo.d-none.d-md-inline.d-lg-inline.d-xl-inline(@click="updateMemo") {{$t('columns.memo')}}: {{device.memo || $t('empty')}}
          b-breadcrumb.lmm-breadcrumb.device_memo.d-none.d-md-flex.d-lg-flex.d-xl-flex(:items="breadcrumb")
        b-row.detail-body
          b-col(cols="12", md="4")
            div.preview
              div.offline-block(v-if="device.alive === 0")
                div OFFLINE
              img.preview-img(
                v-if="device.guid",
                :src="`${AppState.Path.live}/${device.guid}.${device._ext}`",
                @error="onThumbError")
            b-button-group(size="sm", v-if="device.alive === 1")
              b-button(
                v-if="device.approval === 1",
                variant="primary",
                :disabled="!AppState.perm.CSRemoteControl",
                @click="openModal('remote', device)")
                icon.mr-1.dev-action-button(name="play", scale="1.2")
                span {{$t('remote.remote.title')}}
              b-button(
                v-else,
                variant="dark",
                :disabled="!AppState.perm.CSRemoteControl",
                @click="approvalStatus(device)")
                icon.mr-1.dev-action-button(name="exclamation-triangle", scale="1.2")
                span {{$t('remote.approve.desc')}}
              b-button(v-if="AppState.perm.CSFileManager && !AppState.isMobile", @click="openModal('transfer', device)", :disabled="device.disable_filetransfer || device.approval === 0")
                icon.dev-action-button(name="copy", scale="1.2")
                span.sr-only {{$t('remote.transfer.title')}}
            div.mt-2(style="color: #c7c7c7;font-size: 12px;") updated: {{device.system_time}}
          b-col(cols="12", md="8")
            b-row
              b-card-group.w-100
                b-card.process-card.m-1(
                  :header="'CPU ' + $t('use_rate')",
                  header-tag="div",
                  :footer="device.processor",
                  footer-tag="div")
                  div.value
                    | {{device.cpu_usage}}
                    icon(name="percent")
                  div(slot="footer")
                    | {{device.processor || 'NO DATA'}}
                b-card.process-card.m-1(
                  :header="'HDD ' + $t('use_rate')",
                  header-tag="div")
                  div.value
                    | {{device.hdd_usage}}
                    icon(name="percent")
                  div(slot="footer")
                    | {{device.hdd_uses | comma}}MB
                    | /
                    | {{device.hdd_capacity | comma}}MB
                b-card.process-card.m-1(
                  :header="'Memory ' + $t('use_rate')",
                  header-tag="div")
                  div.value
                    | {{device.memory_usage}}
                    icon(name="percent")
                  div(slot="footer")
                    | {{device.memory_uses | comma}}MB
                    | /
                    | {{device.memory_capacity | comma}}MB
            b-row
              b-card.w-100(no-body)
                table.table.table-border(style="margin:0")
                  colgroup
                    col(width="20%")
                    col(width="30%")
                    col(width="20%")
                    col(width="30%")
                  tr
                    th Fan {{$t('speed')}}
                    td {{device.fan_speed_id}}
                    th {{$t('timezone')}}
                    td {{device.time_zone}}
                  tr
                    th CPU {{$t('temperature')}}
                    td {{device.cpu_temp}}
                    th HDD {{$t('temperature')}}
                    td {{device.hdd_temp}}
                  tr
                    th {{$t('running_time')}}
                    td {{device.running_time}}
                    th {{$t('system_time')}}
                    td {{device.system_time}}
                  tr
                    th {{$t('columns.last_connected_time')}}
                    td {{device.last_disconnected_time | moment('YY-MM-DD')}}
                    th {{$t('remote_device')}} {{$t('version')}}
                    td {{device.current_ver}}
        b-row.mt-2
          b-table(
            :fields="network_fields",
            :items="[device]",
            stacked="md",
            bordered)
        b-row
          b-card.w-100.mt-2(no-body)
            b-tabs(card)
              b-tab(:title="$t('access_log')", active)
                b-table(
                  :fields="audit_fields",
                  :items="audit",
                  :empty-text="$t('no-content')",
                  stacked="md",
                  show-empty)
                  template(v-slot:cell(act_time)="{item}")
                    | {{item.act_time | moment('YY-MM-DD HH:mm')}}
                  template(v-slot:cell(action)="{item}")
                    span(v-html="$t(`audit-message[${item.act_name_id}]`, item)")
              b-tab(:title="$t('list_of_process')")
                b-table(
                  :fields="process_fields",
                  :items="process",
                  :empty-text="$t('no-content')",
                  stacked="md",
                  show-empty)
                  template(v-slot:cell(cpu)="row")
                    b-progress(:value="row.item.cpu", :max="100", show-progress, animated)
                  template(v-slot:cell(memory)="row")
                    b-progress(:value="row.item.memory", :max="100", show-progress, animated)
              b-tab(:title="$t('list_of_hardware')")
                b-table(
                  :fields="hardware_fields"
                  :items="hardware",
                  :empty-text="$t('no-content')",
                  stacked="md",
                  show-empty)
              b-tab(:title="$t('list_of_software')")
                b-table(
                  :fields="software_fields"
                  :items="software",
                  :empty-text="$t('no-content')",
                  stacked="md",
                  show-empty)
</template>

<script>
import _ from "lodash"
import store from "@/api/store"
import { user } from "@/api/access"
import { DeviceListAPI, AnalysticAPI, RemoteAPI, ApprovalsAPI } from "@/api"
import { getExt } from "@/api/util"
import router from "@/router"
import rm from "./remote"

const hasAttr = (o, a) => {
  for (let i = 0; i < a.length; i++) {
    let v = a[i]
    if (typeof o[v] !== "string") return false
  }
  return true
}

export default {
  name: "device-detail-component",
  props: {
    devicePk: {
      type: [String, Number],
      required: true,
    },
  },
  methods: {
    // 썸네일 로드 실패(파일 없음 등) 시 기본 이미지로 폴백 (카드뷰 imageError와 동일 취지)
    onThumbError(e) {
      const fallback = `${this.AppState.Path.image}/live/live_no_img.jpg`
      if (e.target.src !== fallback) {
        e.target.src = fallback
      }
    },
    approvalStatus(ctx) {
      let params = {
        context: { path: "reset_n", args: { v: "OTP" } },
        submit: {
          size: "md",
          color: "primary",
          text: "registration",
          sort: "new",
        },
        alias: ctx.alias,
        device_pk: ctx.pk,
      }
      this.AppState.$emit("show-approval-request-dialog", params, (key, data) => {
        if (key === "submit") {
          let submitParams = {
            device_pk: ctx.pk,
            approver_pk: data.approver_pk,
            approver_name: data.approver_name,
            start_time: data.start_time,
            end_time: data.end_time,
            approval_reason: data.approval_reason,
          }
          ApprovalsAPI.post("", submitParams).then(resp => {
            this.$awn.success(this.$t("approval-success"))
          })
        }
      })
    },
    updateAgent() {
      let params = {
        context: {
          path: "update_agent_desc",
          args: { current_ver: this.device.current_ver, latest_ver: this.device.latest_ver },
        },
        withoutInput: true,
        submit: {
          size: "sm",
          color: "success",
          text: "submit",
        },
      }
      this.AppState.$emit("show-confirm-dialog", params, (key, data) => {
        if (key !== "submit") return
        RemoteAPI.put(`${this.device.guid}`, { type: "update" }).then(resp => {
          this.AppState.$emit("show-message-dialog", { context: { path: "update_agent_requested" } })
        })
      })
    },
    removeDevice() {
      let params = {
        context: { path: "confirm_delete_device", args: { name: this.device.alias } },
        withoutInput: true,
        submit: {
          size: "sm",
          color: "danger",
          text: "delete",
        },
      }
      this.AppState.$emit("show-confirm-dialog", params, (key, data) => {
        if (key !== "submit") return

        AnalysticAPI.history.post("audit", {
          act_name_id: 13,
          act_type_id: 5,
          device_pk: this.device.pk,
          member_pk: user().pk,
          new_value: this.device.alias,
          old_value: this.device.dev_os_id,
        })
        rm.remove(this.device)
        DeviceListAPI.delete(`${this.devicePk}`).then(resp => {
          this.AppState.$emit("show-message-dialog", { context: { path: "deleted_device" } })
          this.goback()
          this.AppState.$emit("device-state-change")
        })
      })
    },
    updateMemo() {
      let params = {
        context: { path: "please_input_memo" },
        value: this.device.memo,
        limit: 140,
        placeholder: this.$t("columns.memo"),
        nullable: true,
        textarea: true,
        submit: {
          size: "sm",
          color: "primary",
          text: "submit",
        },
      }
      this.AppState.$emit("show-confirm-dialog", params, (key, value) => {
        if (key !== "submit") return
        DeviceListAPI.put(`${this.devicePk}`, { memo: value }).then(resp => {
          this.AppState.$emit("show-message-dialog", { context: { path: "updated_memo" } })
          this.device.memo = value
          const devpk = parseInt(this.devicePk, 10)
          let pdev = _.find(this.$parent.devicelist, v => v.pk === devpk)
          pdev.memo = value
          store.update("devices", ({ devices }) => {
            let dev = _.find(devices, v => v.pk === devpk)
            dev.memo = value
          })
        })
      })
    },
    getData() {
      let params = {
        by: "create_time",
        device_pk: this.devicePk,
        limit: 10,
        offset: 0,
        order: "desc",
      }
      AnalysticAPI.history.get("audit", { params }).then(resp => {
        let { objects } = resp.data
        this.audit = objects
      })

      DeviceListAPI.get(`${this.devicePk}`).then(resp => {
        let { objects } = resp.data
        if (hasAttr(objects, ["prcss_name", "prcss_cpu_usage", "prcss_memory_usage"])) {
          this.process = _.map(
            _.zip(
              objects.prcss_name.split(";"),
              objects.prcss_cpu_usage.split(";").map(v => parseInt(v, 10)),
              objects.prcss_memory_usage.split(";").map(v => parseInt(v, 10)),
            ),
            values => _.zipObject(["name", "cpu", "memory"], values),
          )
        }
        if (hasAttr(objects, ["hardware_name", "hardware_txt"])) {
          this.hardware = _.map(_.zip(objects.hardware_name.split(";"), objects.hardware_txt.split(";")), values =>
            _.zipObject(["name", "description"], values),
          )
        }
        if (hasAttr(objects, ["software_name", "software_list"])) {
          let softwares = _.chunk(objects.software_list.split(";"), 4)
          this.software = _.map(
            _.zipWith(objects.software_name.split(";"), softwares, (name, list) => {
              list.unshift(name)
              return list
            }),
            values => _.zipObject(["name", "company", "install_date", "version", "description"], values),
          )
        }
        objects._ext = getExt(objects.dev_os_id)
        objects.memory_uses = Math.round((objects.memory_usage / 100) * objects.memory_capacity)
        objects.hdd_uses = Math.round((objects.hdd_usage / 100) * objects.hdd_capacity)
        this.device = objects
        this.dataIsLoaded = true
      })
    },
    goback() {
      router.push({
        name: "deviceAll",
        params: this.$route.params,
        query: this.$route.query,
      })
    },
    openModal(name, device) {
      if (device.alive === 0) {
        let params = {
          title: "LinkMeMine",
          context: { path: "not_online_warning" },
        }
        this.AppState.$emit("show-message-dialog", params)
        return
      }

      const { isMobile, isApplication, os } = this.AppState
      if (isMobile && !isApplication && name === "remote") {
        let params = {
          context: {
            path: "mobile_store",
            args: { url: this.AppState.mobile[os] },
          },
        }
        return this.AppState.$emit("show-message-dialog", params)
      }

      //보안서약서
      if (name === "remote" && device.security_agreement) {
        let params = {
          title: "test",
        }
        this.AppState.$emit("show-security-dialog", params, (key, data) => {
          if (key == "submit") {
            let params = {
              title: this.$t(`remote.${name}.title`),
              context: this.$t(`remote.${name}.desc`),
              buttons: [
                {
                  size: "sm",
                  color: "primary",
                  text: this.$t("execute"),
                  action: close => {
                    const resp = rm[name](device)
                    if (resp === false) this.$awn.alert(this.$t("not_supported_os"))
                    this.$awn.success(this.$t(`remote.${name}.${resp}`))
                    close()
                  },
                },
              ],
            }

            this.AppState.$emit("show-action-dialog", params)
          }
        })
        return
      }

      let params = {
        title: this.$t(`remote.${name}.title`),
        context: this.$t(`remote.${name}.desc`),
        buttons: [
          {
            size: "sm",
            color: "primary",
            text: this.$t("execute"),
            action: close => {
              const resp = rm[name](device)
              if (resp === false) this.$awn.alert(this.$t("not_supported_os"))
              this.$awn.success(this.$t(`remote.${name}.${resp}`))
              close()
            },
          },
        ],
      }

      this.AppState.$emit("show-action-dialog", params)
    },
  },
  computed: {
    breadcrumb() {
      let groups = this.$parent.grouplist
      let device = this.device
      let result = [
        {
          text: device.alias,
          active: true,
        },
      ]

      const addGroup = pk => {
        let g = _.find(groups, { pk })
        if (g) {
          result.unshift({ text: g.name, active: true })
          if (g.group_fk) addGroup(g.group_fk)
        } else {
          result.unshift({ text: this.$t("reserved.ROOT"), active: true })
        }
      }

      if (device.device_group_fk) addGroup(device.device_group_fk)
      else result.unshift({ text: this.$t("all_device"), active: true })

      return result
    },
  },
  watch: {
    devicePk(n, o) {
      this.getData()
    },
  },
  mounted() {
    this.getData()
  },
  data() {
    return {
      dataIsLoaded: false,
      audit: [],
      device: {},
      process: [],
      hardware: [],
      software: [],
      audit_fields: [
        { key: "name", label: this.$t("name") },
        { key: "reg_mail", label: this.$t("ID") },
        { key: "act_time", label: this.$t("execute") + " " + this.$t("at_time") },
        { key: "action", label: this.$t("remote.detail.title") },
      ],
      process_fields: [
        { key: "name", label: this.$t("name") },
        { key: "cpu", label: "CPU " + this.$t("use_rate") },
        { key: "memory", label: "Memory " + this.$t("use_rate") },
      ],
      hardware_fields: [
        { key: "name", label: this.$t("name") },
        { key: "description", label: this.$t("remote.detail.title") },
      ],
      software_fields: [
        { key: "name", label: this.$t("name") },
        { key: "company", label: this.$t("company") },
        { key: "install_date", label: this.$t("date") },
        { key: "version", label: this.$t("version") },
        { key: "description", label: this.$t("remote.detail.title") },
      ],
      network_fields: [
        { key: "ip_addr", label: "IP" },
        { key: "netmask", label: "Netmask" },
        { key: "gateway", label: "Gateway" },
        { key: "dns", label: "DNS" },
        { key: "mac_addr", label: "MAC Address" },
        { key: "bios", label: "BIOS " + this.$t("version") },
      ],
    }
  },
}
</script>

<style lang="scss" scoped>
.popover-content {
  // position: absolute;
  // top: 53px; left: 220px; right: 0; bottom: 0;
  position: relative;
  margin: 50px;
  // min-height: 100%;
  background-color: #ebebeb;
  padding: 20px;
  // overflow: hidden;
  transition: margin 300ms;
  @media (max-width: 768px) {
    margin-left: 0px !important;
  }
  .sidebar-close & {
    margin-left: 0px !important;
  }
  max-width: none;
  max-height: none;
  overflow: visible;
}
.detail-inner {
  // position: absolute;
  // top: 53px; left: 220px; right: 0; bottom: 0;
  position: relative;
  margin: 69px 0 0 220px;
  min-height: 100%;
  background-color: #ebebeb;
  padding: 20px;
  overflow: hidden;
  transition: margin 300ms;
  @media (max-width: 768px) {
    margin-left: 0px !important;
  }
  .sidebar-close & {
    margin-left: 0px !important;
  }
}

.detail-inner-icon-view {
  position: relative;
  margin-top: 53px;
  min-height: 100%;
  background-color: #ebebeb;
  padding: 20px;
  overflow: hidden;
  transition: margin 300ms;
  @media (max-width: 768px) {
    margin-left: 0px !important;
  }
  .sidebar-close & {
    margin-left: 0px !important;
  }
}
.detail-header {
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  height: 50px;
  line-height: 50px;
  background-color: #d9d9d9;

  > span {
    font-size: 20px;
    color: #656565;

    &.device_memo {
      display: inline-block;
      font-size: 100%;
      margin-left: 20px;
      padding: 5px;
      border-radius: 4px;
      border: 1px solid #b7b7b7;
      color: #909090;
      line-height: 100%;
      cursor: pointer;
    }
  }

  > .plain-button {
    height: 48px;
    padding: 0 12px;
    margin-right: 20px;
    color: #656565;
    font-size: 16px;
    background-color: #c2c2c2;
  }
}
.detail-body {
  padding-top: 40px;
}
.preview {
  margin: 0.25rem 0;
  position: relative;

  // 썸네일: 가로(PC)는 폭에 맞춰 채우고, 세로(Android)는 높이를 캡해 과하게 길어지지 않게.
  // max-width/max-height 조합이라 두 방향 모두 비율 유지하며 박스 안에 contain된다.
  .preview-img {
    display: block;
    margin: 0 auto;      // 세로 이미지는 폭이 좁아지므로 가운데 정렬
    max-width: 100%;     // 가로(PC): 컬럼 폭에 맞춤
    max-height: 60vh;    // 세로(Android): 높이 상한 (값 조정 가능)
    width: auto;
    height: auto;
  }
}

.offline-block {
  position: absolute;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
  background-color: rgba(255, 255, 255, 0.75);
  z-index: 5;
  > div {
    font-size: 32px;
    font-weight: bold;
    text-align: center;
    height: 40px;
    position: absolute;
    top: 50%;
    left: 0;
    right: 0;
    margin-top: -27px;
  }
}

.process-card {
  // .card-header {}
  .value {
    text-align: center;
    font-size: 32px;
  }
  .card-footer {
    color: #c7c7c7;
    div {
      white-space: nowrap;
      text-overflow: ellipsis;
      overflow: hidden;
    }
  }
}
.static-table {
  width: 100%;
  background-color: #ffffff;
}

.dev-action-button {
  vertical-align: -4px;
  width: 25px;
  .dropdown-item & {
    color: #d2d2d2;
  }
}

.lmm-breadcrumb {
  position: absolute;
  top: 0;
  right: 100px;
  padding: 0;
  margin: 0;
  background-color: transparent;
}

.lmm-btn-delete {
  position: absolute;
  top: 10px;
  right: 25px;
}
</style>
